import { FakePageData } from '@4finance/cwt-test-helper';
import { phoneVerificationScenarios } from 'utils/TestHelper/scenarios/phone_verification.scenario';
import { personalDetailsScenarios } from 'utils/TestHelper/scenarios/personal_details.scenario';
import { financeScenarios } from 'utils/TestHelper/scenarios/finance.scenario';
import { consentScenarios } from 'utils/TestHelper/scenarios/consent.scenario';
import { continuePagesScenario } from 'utils/TestHelper/scenarios/continue_pages.scenario';
import { accountSelectionScenario } from 'utils/TestHelper/scenarios/account_selection.scenario';
import { psd2consentsScenario } from 'utils/TestHelper/scenarios/psd2consents.scenario';
import { signAgreementScenarios } from 'utils/TestHelper/scenarios/sign_agreement.scenario';

const scenarios: FakePageData[] = [
  personalDetailsScenarios,
  phoneVerificationScenarios,
  financeScenarios,
  consentScenarios,
  accountSelectionScenario,
  psd2consentsScenario,
  signAgreementScenarios,
  ...continuePagesScenario,
];

export { scenarios };
